export const NEW_FISH_INTRO_ANIMATIONS = new Set(["enlarge", "spinDisapear"]);

export function isHorizontalLapAnimationEnd(event, horizontalAnimationName) {
    if (!event || event.target !== event.currentTarget) return false;
    if (NEW_FISH_INTRO_ANIMATIONS.has(event.animationName)) return false;
    if (!horizontalAnimationName || !event.animationName) return true;
    return event.animationName === horizontalAnimationName
        || String(event.animationName).includes("fish-animation-horizontal");
}

export function isNewFishIntroAnimationEnd(event) {
    if (!event || event.target === event.currentTarget) return false;
    return NEW_FISH_INTRO_ANIMATIONS.has(event.animationName);
}

/**
 * A finished horizontal lap (fish is off-screen) starts a new random route.
 * Bubbled enlarge/shine/bob events must not change the route mid-swim.
 */
export function resolveHorizontalAnimationEnd(event, { isNew, horizontalAnimationName } = {}) {
    if (isNewFishIntroAnimationEnd(event)) {
        return { nextLap: false, clearIsNew: !!isNew };
    }
    if (isHorizontalLapAnimationEnd(event, horizontalAnimationName)) {
        return { nextLap: true, clearIsNew: false };
    }
    return { nextLap: false, clearIsNew: false };
}

export function resolveHorizontalAnimationIteration(event, { horizontalAnimationName } = {}) {
    if (!isHorizontalLapAnimationEnd(event, horizontalAnimationName)) {
        return { nextLap: false };
    }
    return { nextLap: true };
}
